import { CartItemDto } from "@/types/dto/cart-item-dto";

export const getDefaultDiscountText = (item: CartItemDto) => {
  // if (item.discountRate === 0) {
  //   return "0";
  // }

  return item.discountRate >= item.gradeDiscountRate
    ? `상품 할인 ${item.discountRate}%`
    : `등급 할인 ${item.gradeDiscountRate}%`;
};
